"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconOnlineUse = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var IconOnlineUse = function (props) {
    var theme = styled_components_1.useTheme();
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#464650", d: "M18,16 C18,18.617 15.378,21 12.5,21 C9.622,21 7,18.617 7,16 L7,8.309 L11,10.309 L11,9.5 C11,9.399 11.011,9.301 11.03,9.206 L7.082,7.232 C7.5,5.084 9.607,3.253 12,3.025 L12,8.093 C12.157,8.036 12.324,8 12.5,8 C12.676,8 12.843,8.036 13,8.093 L13,3.025 C15.393,3.253 17.5,5.084 17.918,7.232 L13.97,9.206 C13.989,9.301 14,9.399 14,9.5 L14,10.309 L18,8.309 L18,16 Z M12.5,2 C9.038,2 6,4.804 6,8 L6,16 C6,19.196 9.038,22 12.5,22 C15.962,22 19,19.196 19,16 L19,8 C19,4.804 15.962,2 12.5,2 L12.5,2 Z" }),
            React.createElement("path", { fill: !!theme ? (theme.name !== 'privalia' ? theme.colors.main.base : theme.colors.red.s75) : '#EC008C', d: "M12.5,12 L12.5,12 C11.675,12 11,11.325 11,10.5 L11,9.5 C11,8.675 11.675,8 12.5,8 C13.325,8 14,8.675 14,9.5 L14,10.5 C14,11.325 13.325,12 12.5,12" }))));
};
exports.IconOnlineUse = IconOnlineUse;
exports.IconOnlineUse.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconOnlineUse;
